var _path;

import * as React from "react";

function SvgWatchlist(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.133 7.2a2.134 2.134 0 110 4.267 2.134 2.134 0 010-4.267zm28.267.534c.887 0 1.6.716 1.6 1.6 0 .886-.713 1.6-1.6 1.6H14.133c-.886 0-1.6-.714-1.6-1.6 0-.884.714-1.6 1.6-1.6H34.4zm0 10.666c.887 0 1.6.713 1.6 1.6 0 .887-.713 1.6-1.6 1.6H14.133c-.886 0-1.6-.713-1.6-1.6 0-.887.714-1.6 1.6-1.6H34.4zm0 10.667c.887 0 1.6.713 1.6 1.6 0 .886-.713 1.6-1.6 1.6H14.133c-.886 0-1.6-.714-1.6-1.6 0-.887.714-1.6 1.6-1.6H34.4zM6.133 22.134a2.132 2.132 0 110-4.267 2.132 2.132 0 110 4.267zm0 6.4a2.132 2.132 0 110 4.266 2.132 2.132 0 110-4.266z"
  })));
}

export default SvgWatchlist;